<script setup lang="ts">
import type {
	PropertyPhotoCarouselSingleItemEmits,
	PropertyPhotoCarouselSingleItemProps
} from '.';

const props = withDefaults(
	defineProps<PropertyPhotoCarouselSingleItemProps>(),
	{
		isLoading: false,
		skeletonVariant: 'white',
		imageProps: () => ({
			preload: false,
			fetchpriority: 'auto',
			decoding: 'async',
			loading: 'lazy'
		})
	}
);

const emit = defineEmits<PropertyPhotoCarouselSingleItemEmits>();

function handlePhotoClick() {
	emit('photo-clicked', props.photoIndex, props.photo.watermarkUrl);
}
</script>

<template>
	<div class="relative size-full overflow-hidden bg-black">
		<Skeleton
			:is-active="isLoading"
			class="size-full"
			:variant="props.skeletonVariant"
		>
			<NuxtImg
				:src="photo.watermarkUrl"
				:alt="altText"
				width="960"
				sizes="lg:640px xl:800px 2xl:960px"
				densities="x1"
				:preload="imageProps.preload ? { fetchPriority: 'high' } : undefined"
				:decoding="imageProps.decoding"
				:loading="imageProps.loading"
				class="size-full cursor-pointer object-cover object-center"
				format="webp"
				quality="80"
				@click="handlePhotoClick"
			/>
		</Skeleton>
	</div>
</template>
